<section class="employee-credentials">
  <div class="employee-credentials__icon"><mat-icon>key</mat-icon></div>
  <h2 mat-dialog-title>{{ data.title || ('employeesCatalog.provisioning.title' | translate) }}</h2>

  <mat-dialog-content>
    <p>{{ data.description || ('employeesCatalog.provisioning.description' | translate) }}</p>
    <div class="employee-credentials__warning">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ 'employeesCatalog.provisioning.oneTimeWarning' | translate }}</span>
    </div>

    <div class="employee-credentials__field">
      <span>{{ data.accountLabel }}</span>
      <strong>{{ data.account }}</strong>
    </div>
    <div class="employee-credentials__field">
      <span>{{ 'employeesCatalog.provisioning.temporaryPassword' | translate }}</span>
      @if (password) {
        <code>{{ password }}</code>
      } @else {
        <strong class="employee-credentials__copied"><mat-icon>check_circle</mat-icon>{{ 'employeesCatalog.provisioning.copied' | translate }}</strong>
      }
    </div>

    @if (data.mustChangePassword) {
      <p class="employee-credentials__note">{{ 'employeesCatalog.provisioning.mustChangePassword' | translate }}</p>
    }
    @if (copyFailed) {
      <p class="employee-credentials__error">{{ 'employeesCatalog.provisioning.copyError' | translate }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-stroked-button (click)="close()">
      {{ 'employeesCatalog.provisioning.close' | translate }}
    </button>
    <button type="button" mat-flat-button color="primary" (click)="copyPassword()" [disabled]="!password">
      <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
      {{ (copied ? 'employeesCatalog.provisioning.copied' : 'employeesCatalog.provisioning.copyPassword') | translate }}
    </button>
  </mat-dialog-actions>
</section>
